import { render, staticRenderFns } from "./guardianVerificationLanding.vue?vue&type=template&id=54ac3ee7&scoped=true&lang=pug&"
import script from "./guardianVerificationLanding.vue?vue&type=script&lang=js&"
export * from "./guardianVerificationLanding.vue?vue&type=script&lang=js&"
import style0 from "./guardianVerificationLanding.vue?vue&type=style&index=0&id=54ac3ee7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac3ee7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ac3ee7')) {
      api.createRecord('54ac3ee7', component.options)
    } else {
      api.reload('54ac3ee7', component.options)
    }
    module.hot.accept("./guardianVerificationLanding.vue?vue&type=template&id=54ac3ee7&scoped=true&lang=pug&", function () {
      api.rerender('54ac3ee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/guardianVerificationLanding/guardianVerificationLanding.vue"
export default component.exports